import { useTranslation } from 'react-i18next'
import type { SettlementBalance } from '@services/settlements/types'

import { cn } from '@/lib/utils'

import { absoluteAmount, isUnderpayment, money } from './format'

/**
 * The one place the words "nedoplatok" and "preplatok" are chosen. The sign
 * lives in the wording, never in front of the number — the spreadsheets
 * flipped their convention between files and became impossible to compare.
 */
export function SettlementBalanceRow({
  label,
  balance,
  emphasis = false
}: {
  label: string
  balance: SettlementBalance
  emphasis?: boolean
}) {
  const { t } = useTranslation('settlement')
  const underpayment = isUnderpayment(balance.balance)

  return (
    <div className="flex flex-wrap items-baseline justify-between gap-x-4 gap-y-1 py-2">
      <span
        className={cn(
          'text-ink',
          emphasis ? 'font-display text-lg font-bold' : 'font-medium'
        )}
      >
        {label}
      </span>

      <span className="text-xs text-muted-foreground">
        {t('result.cost')} {money(balance.cost)} − {t('result.advances')}{' '}
        {money(balance.advances)}
      </span>

      <span
        className={cn(
          'tabular-nums',
          emphasis ? 'font-display text-lg font-bold' : 'font-semibold',
          underpayment ? 'text-destructive' : 'text-success'
        )}
      >
        {underpayment ? t('result.underpayment') : t('result.overpayment')}{' '}
        {money(absoluteAmount(balance.balance))}
      </span>
    </div>
  )
}
